import { toast } from 'sonner';
import { TNotificationState } from '../../types';
import NOTIFICATION_TYPES from '../../constants';

type TUseNotificationReturn = {
  customNotification: (value: Partial<TNotificationState>) => void;
  successNotification: (message: string) => void;
  errorNotification: (message: string) => void;
  infoNotification: (message: string) => void;
  closeNotification: () => void;
};

const useNotifications = (): TUseNotificationReturn => {
  const successNotification = (message: string) => {
    toast.success(message);
  };

  const errorNotification = (message: string) => {
    toast.error(message);
  };

  const infoNotification = (message: string) => {
    toast.info(message);
  };

  const customNotification = (data: Partial<TNotificationState>) => {
    const { message = '', notificationType, timeout = 5000 } = data;

    const options = {
      duration: timeout,
    };

    switch (notificationType) {
      case NOTIFICATION_TYPES.SUCCESS:
        toast.success(message, options);
        break;
      case NOTIFICATION_TYPES.ERROR:
        toast.error(message, options);
        break;
      case NOTIFICATION_TYPES.INFO:
        toast.info(message, options);
        break;
      default:
        toast(message, options);
    }
  };

  const closeNotification = () => {
    toast.dismiss();
  };

  return {
    customNotification,
    successNotification,
    errorNotification,
    infoNotification,
    closeNotification
  };
};

export default useNotifications;
